import { render } from "./CheckboxInput.vue?vue&type=template&id=36310cca&ts=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts"

import "./CheckboxInput.vue?vue&type=style&index=0&id=36310cca&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__